/*
 * Componente para exibir a página de visualização de um artigo
*/
import ViewArtigo from "../../componentes/ViewArtigo";

const VerArtigo = () => {
    return (
        <div>
            <ViewArtigo />
        </div>
    );

}

export default VerArtigo;